module.exports = __webpack_public_path__ + "media/images/powerpoint/media/target-ac25b4f8af244588e90c703578984264.png";